// extracted by mini-css-extract-plugin
module.exports = {"hidden":"fileAttachment_hidden__RFtlB","textEmphasis":"fileAttachment_textEmphasis__7HX_m","noticeArea":"fileAttachment_noticeArea__29a_p"};